// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import {IProductEnvironment} from "./FacilitiesEvaluationEnvironment";
import {EProductType} from "../javascript.lib.mojo-base/model/ProductType";
import {FacilityAccessibilityProduct4} from "../product.facility/model/FacilityAccessibilityProduct4";

export const environment: IProductEnvironment = {

  name: 'Walmart: Facilities',
  filename: 'environment.facilities-877784.ts',

  isDevelopment: false,
  isProduction: true,
  isTest: false,

  authenticationConfig: {

    emailLink: false,
    textMessage: false,
    usernamePassword: true
  },

  firebaseConfig: {
    apiKey: "AIzaSyAEwIE5MdMakEatCla88o_BUlgam4_xWDI",
    authDomain: "facilities-877784.firebaseapp.com",
    databaseURL: "https://facilities-877784-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "facilities-877784",
    storageBucket: "facilities-877784.appspot.com",
    messagingSenderId: "720075764245",
    appId: "1:720075764245:web:3ee078ef34c2222594541c"
  },

  // curl -iLS https://us-central1-$_TARGET_ENV.cloudfunctions.net/public/functions/info
  cloudFunctionsUrl: 'https://us-central1-facilities-877784.cloudfunctions.net',

  nocoDbConfig: {
    // httpServer: 'http://localhost:8080',
    // httpServer: 'http://spot.local:8080',
    httpServer: 'https://mobilitymojo-spot.com',
    user: 'test@mobilitymojo.com',
    password: 'test@mobilitymojo.com',
    authorization: 'Basic bW9iaWxpdHk6bW9qbw==',
    // projectTitle: 'products-playpen',
    projectTitle: '2024 - Grosvenor and The Crown Estate',
  },

  productConfig: {

    firebaseAnswersRoot: '/answers-x/facilities',
    // product:  ProductHelper.cloneProduct( new FacilityAccessibilityProduct(), true )
    product:  FacilityAccessibilityProduct4.INSTANCE,
    productType: EProductType.facilities,
    canCommentOnClusters: true,
    canEditClusters: false,

  },

  preview: {

    // fireworksEnabled: true,
    // reportGeneration2: true,
    clusterSupport: true,
  },



};
